var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{staticClass:"md-sm md-info md-reload",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('reload')}}},[_c('md-icon',[_vm._v("refresh")]),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }